// client/src/components/DefaultLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const DefaultLayout = () => {
    // Manage sidebar collapsed state with localStorage persistence
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
        const saved = localStorage.getItem('sidebarCollapsed');
        return saved ? JSON.parse(saved) : false;
    });

    // Save sidebar state to localStorage when it changes
    useEffect(() => {
        localStorage.setItem('sidebarCollapsed', JSON.stringify(isSidebarCollapsed));
    }, [isSidebarCollapsed]);

    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    return (
        <div className="min-h-screen flex flex-col">
            {/* Header - Full width across the top */}
            <Navbar />

            {/* Content area with sidebar */}
            <div className="flex flex-1">
                {/* Sidebar - Desktop only, below header */}
                <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />

                {/* Main content area */}
                <main className="flex-grow bg-gray-50">
                    <Outlet /> {/* This will render the nested private route components */}
                </main>
            </div>
        </div>
    );
};

export default DefaultLayout;